import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PROVIDER_GET_MAPPED_PROVIDERS_IN_RANGE } from 'api/utilityActionTypes';

export const getRangeIdentifier = ({ latitude, longitude, rangeInMiles, utilityTypeId }) => {
  typeCheck('latitude::Number', latitude);
  typeCheck('longitude::Number', longitude);
  typeCheck('rangeInMiles::Number', rangeInMiles);
  typeCheck('utilityTypeId::Maybe PositiveNumber', utilityTypeId);

  return [latitude, longitude, rangeInMiles, utilityTypeId || 'all'].join('_');
};

export default async function getMappedProvidersInRange(
  { state, utilityApiClient },
  { latitude, longitude, rangeInMiles, utilityTypeId, refresh } = {},
) {
  typeCheck('latitude::Number', latitude);
  typeCheck('longitude::Number', longitude);
  typeCheck('rangeInMiles::Number', rangeInMiles);
  typeCheck('utilityTypeId::Maybe PositiveNumber', utilityTypeId);
  typeCheck('refresh::Maybe Boolean', refresh);

  const rangeIdentifier = getRangeIdentifier({ latitude, longitude, rangeInMiles, utilityTypeId });
  const statePath = ['utilityProviders', 'coverageByRange', rangeIdentifier];

  if (!refresh && state.get(statePath)) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PROVIDER_GET_MAPPED_PROVIDERS_IN_RANGE,
    state: state,
    payload: {
      latitude,
      longitude,
      rangeInMiles,
      utilityTypeId,
    },
    onSuccess(mappedUtilityProvidersInRange) {
      state.set(statePath, mappedUtilityProvidersInRange);
      return mappedUtilityProvidersInRange;
    },
  });
}
